export const DEFAULT_DOCUMENT_TITLE = 'Leaply'
export const DEFAULT_DOCUMENT_DESCRIPTION =
  'Leaply is a modern graduate recruitment platform that integrates an applicant tracking system so employers can find suitable candidates easily and applicants get feedback as the hiring process progresses. Find or list jobs, bursaries or events on Leaply easily!'
export const DEFAULT_DOCUMENT_IMAGE = 'https://leap.ly/images/leaply-sig-2016.png'

const setMetaContent = (selector, value) => {
  if (typeof document === 'undefined' || !document.head) return

  const element = document.head.querySelector(selector)
  if (!element) return

  element.content = value
}

export const managedDocumentAttributes = {
  destroyed() {
    if (typeof document === 'undefined' || !document.head) return

    document.title = DEFAULT_DOCUMENT_TITLE
    setMetaContent('meta[name=description]', DEFAULT_DOCUMENT_DESCRIPTION)
    setMetaContent('meta[property="og:image"]', DEFAULT_DOCUMENT_IMAGE)
  },

  data() {
    return {
      documentAttributes: {
        title: DEFAULT_DOCUMENT_TITLE,
        description: DEFAULT_DOCUMENT_DESCRIPTION,
        image: DEFAULT_DOCUMENT_IMAGE,
      },
    }
  },

  watch: {
    'documentAttributes.title': function(value) {
      if (typeof document === 'undefined') return

      document.title = value || DEFAULT_DOCUMENT_TITLE
    },
    'documentAttributes.description': function(value) {
      setMetaContent(
        'meta[name=description]',
        value || DEFAULT_DOCUMENT_DESCRIPTION
      )
    },
    'documentAttributes.image': function(value) {
      setMetaContent(
        'meta[property="og:image"]',
        value || DEFAULT_DOCUMENT_IMAGE
      )
    },
  },
}

export default {
  managedDocumentAttributes
}
